import React, { Component, Fragment } from 'react'

// Components
import Select from 'react-select'
import Loader from '../../utils/Loader'
import NumberFormat from 'react-number-format'
import CategorySearch from '../products/category-search/CategorySearch'
import ProductSearch from '../products/product-search/ProductSearch'
import BuyXGetYField from './BuyXGetYField'

import '../../../css/react-select.css'

class BuyXGetY extends Component {
	constructor(props) {
		super(props)
		this.state = {
			updateLoading: false,
			loading: false,
		}

		this.discountTypes = [
			{ type: 'percentage', label: 'Percentage (%)' },
			{ type: 'dollar', label: 'Dollar ($)' },
			{ type: 'free', label: 'Free' },
		]

		this.reqTypes = [
			{ type: 'value', label: 'Dollar ($)' },
			{ type: 'quantity', label: 'Quantity (#)' },
		]
	}

	getSelectValue = (select_type, value) => {
		if (select_type === 'reqTypes') return this.reqTypes.find(o => o.type === value)
		else return this.discountTypes.find(o => o.type === value)
	}

	render() {
		const { updateLoading, loading } = this.state
		const { item, index, editId } = this.props

		// console.log(this.getSelectValue('discountTypes', item.discount_type));
		return (
			<Fragment>
				{loading ? (
					<div className='pt2 pb2'>
						<Loader />
					</div>
				) : (
					<div className='discount-edit'>
						<div className='discount-edit-header'>
							{editId !== null ? 'Edit Buy X Get Y Code:' : 'Add Buy X Get Y  Code:'}
						</div>
						<div className='discount-edit-row1'>
							<BuyXGetYField
								type={'text'}
								item={item}
								field={'code'}
								label={'Coupon Code'}
								placeholder={'Enter coupon code'}
								handleChange={(value, field) => this.props.handleChange(value, index, field)}
							/>
							<BuyXGetYField
								type={'text'}
								item={item}
								field={'message'}
								label={'Message'}
								placeholder={'Enter message'}
								handleChange={(value, field) => this.props.handleChange(value, index, field)}
							/>
							<input type='hidden' value={item.id ? item.id : ''} />
						</div>
						<div className='discount-edit-row2'>
							<div className='bg'>
								{/* CUSTOMER BUYS - LEFT COL */}
								<div className='bg-col'>
									<div className='bg-col-head'>CUSTOMER BUYS</div>
									<div className='bg-col-min'>
										<div className='bg-col-min-head'>Minimum Type & Amount</div>
										{!!item.errors && !!item.errors.req_value && (
											<div className='error msg_animate'>{item.errors.req_value}</div>
										)}
										<div className='bg-col-min-form'>
											<Select
												classNamePrefix='react-select'
												className='select-box'
												name={`req_type`}
												placeholder='Select Type'
												value={this.getSelectValue('reqTypes', item.req_type)}
												onChange={selection =>
													this.props.handleSelectBoxChange(selection, 'req_type')
												}
												isClearable={false}
												isSearchable={false}
												options={this.reqTypes}
											/>
											{item.req_type === 'value' && (
												<NumberFormat
													value={item.req_value}
													placeholder='0.00'
													prefix={'$'}
													decimalScale={2}
													fixedDecimalScale={true}
													thousandSeparator={true}
													onChange={e =>
														this.props.handleChange(e.target.value, index, 'req_value')
													}
													renderText={formattedValue => <div>{formattedValue}</div>}
												/>
											)}
											{item.req_type === 'quantity' && (
												<NumberFormat
													value={item.req_value}
													placeholder='0'
													prefix={''}
													decimalScale={0}
													fixedDecimalScale={false}
													thousandSeparator={true}
													onChange={e =>
														this.props.handleChange(e.target.value, index, 'req_value')
													}
													renderText={formattedValue => <div>{formattedValue}</div>}
												/>
											)}
										</div>
										{item.req_type === 'value' ? (
											<div className='custom-label checkbox-label nobuyitems-checkbox'>
												<input
													type='checkbox'
													id='no_buy_items'
													checked={item.no_buy_items}
													disabled={item.buy_categories.length > 0 || item.buy_products.length > 0}
													onChange={e => this.props.handleCheckboxClick(index, 'no_buy_items')}
												/>
												<label
													htmlFor='no_buy_items'
													className={`no-blue ${
														item.buy_categories.length > 0 || item.buy_products.length > 0
															? ' disabled'
															: ''
													}`}
												>
													Only require dollar value?
												</label>
											</div>
										) : (
											<Fragment />
										)}
									</div>
									<div className='bg-col-error'>
										{!!item.errors && !!item.errors.buy_error && (
											<div className='error msg_animate'>{item.errors.buy_error}</div>
										)}
									</div>
									<div className='bg-col-body'>
										<div className='bg-col-body-col'>
											<div className='bg-col-body-col-head'>Products</div>
											<div className='bg-col-body-col-search'>
												<ProductSearch
													currentlySelected={item.buy_products}
													updateHandler={selections =>
														this.props.handleCatProdChange(selections, 'buy_products')
													}
													disabled={
														item.buy_categories.length > 0 ||
														item.buy_products.length > 0 ||
														item.no_buy_items
													}
													ignoreVariants={false}
												/>
												<div className='selected-item-wrapper'>
													{!!item.buy_products &&
														item.buy_products.map((product, i) => {
															return (
																<div key={i} className='selected-item'>
																	<div className='txt'>{product.title}</div>
																	<input type='hidden' name='buy_products[]' value={product.id} />
																	<span
																		className='icon-cross delete-category'
																		onClick={() => {
																			this.props.handleCatProdDelete(i, 'buy_products')
																		}}
																	/>
																</div>
															)
														})}
												</div>
											</div>
										</div>
										<div className='bg-col-body-col-seperator' />
										<div className='bg-col-body-col'>
											<div className='bg-col-body-col-head'>Categories</div>
											<div className='bg-col-body-col-search'>
												<CategorySearch
													currentlySelected={item.buy_categories}
													updateHandler={selections =>
														this.props.handleCatProdChange(selections, 'buy_categories')
													}
													disabled={
														item.buy_categories.length > 0 ||
														item.buy_products.length > 0 ||
														item.no_buy_items
													}
												/>
												<div className='selected-item-wrapper'>
													{!!item.buy_categories &&
														item.buy_categories.map((category, i) => {
															return (
																<div key={i} className='selected-item'>
																	<div className='txt'>{category.title}</div>
																	<input
																		type='hidden'
																		name='buy_categories[]'
																		value={category.id}
																	/>
																	<span
																		className='icon-cross delete-category'
																		onClick={() => {
																			this.props.handleCatProdDelete(i, 'buy_categories')
																		}}
																	/>
																</div>
															)
														})}
												</div>
											</div>
										</div>
									</div>
								</div>
								{/* CUSTOMER GETS - RIGHT COL */}
								<div className='bg-col'>
									<div className='bg-col-head'>CUSTOMER GETS</div>
									<div className='bg-col-min'>
										<div className='bg-col-min-head'>Discount Type & Amount</div>
										{!!item.errors && !!item.errors.discount_value && (
											<div className='error msg_animate'>{item.errors.discount_value}</div>
										)}
										<div className='bg-col-min-form'>
											<Select
												classNamePrefix='react-select'
												className='select-box'
												name={`discount_type`}
												placeholder='Select Type'
												value={this.getSelectValue('discountTypes', item.discount_type)}
												onChange={selection =>
													this.props.handleSelectBoxChange(selection, 'discount_type')
												}
												isClearable={false}
												isSearchable={false}
												options={this.discountTypes}
											/>
											{item.discount_type === 'percentage' && (
												<NumberFormat
													value={item.discount_value}
													placeholder='0.00'
													suffix={'%'}
													decimalScale={2}
													fixedDecimalScale={true}
													thousandSeparator={true}
													onChange={e =>
														this.props.handleChange(e.target.value, index, 'discount_value')
													}
												/>
											)}
											{item.discount_type === 'dollar' && (
												<NumberFormat
													value={item.discount_value}
													placeholder='0.00'
													prefix={'$'}
													decimalScale={2}
													fixedDecimalScale={true}
													thousandSeparator={true}
													onChange={e =>
														this.props.handleChange(e.target.value, index, 'discount_value')
													}
												/>
											)}
											{item.discount_type === 'free' && (
												<NumberFormat value={'No Amount'} placeholder='No Amount' disabled={true} />
											)}
										</div>
									</div>
									<div className='bg-col-error'>
										{!!item.errors && !!item.errors.get_error && (
											<div className='error msg_animate'>{item.errors.get_error}</div>
										)}
									</div>
									<div className='bg-col-body'>
										<div className='bg-col-body-col'>
											<div className='bg-col-body-col-head'>Products</div>
											<div className='bg-col-body-col-search'>
												<ProductSearch
													currentlySelected={item.get_products}
													updateHandler={selections =>
														this.props.handleCatProdChange(selections, 'get_products')
													}
													disabled={item.get_products.length > 0 || item.get_categories.length > 0}
													ignoreVariants={false}
												/>
												<div className='selected-item-wrapper'>
													{!!item.get_products &&
														item.get_products.map((product, i) => {
															return (
																<div key={i} className='selected-item-qty-container'>
																	<div className='selected-item'>
																		<div className='txt'>{product.title}</div>
																		<input type='hidden' name='get_products[]' value={product.id} />
																		<span
																			className='icon-cross delete-category'
																			onClick={() => {
																				this.props.handleCatProdDelete(i, 'get_products')
																			}}
																		/>
																	</div>
																	{!!item.errors && !!item.errors.discount_qty && (
																		<div
																			className='error msg_animate'
																			style={{ margin: '0.75em 0em' }}
																		>
																			{item.errors.discount_qty}
																		</div>
																	)}
																	<div className='qty-group'>
																		<div className='qty-label'>Max Quantity: </div>
																		<input
																			type='number'
																			placeholder='Enter quantity'
																			value={item.discount_qty}
																			onChange={e =>
																				this.props.handleChange(
																					e.target.value,
																					index,
																					'discount_qty'
																				)
																			}
																		/>
																	</div>
																	{item.get_products[0]['no_variants'] ? (
																		<div className='custom-label checkbox-label autoadd-checkbox'>
																			<input
																				type='checkbox'
																				id='auto_add'
																				checked={item.auto_add}
																				onChange={e =>
																					this.props.handleCheckboxClick(index, 'auto_add')
																				}
																			/>
																			<label htmlFor='auto_add'>
																				Auto-add this product after coupon is applied?
																			</label>
																		</div>
																	) : (
																		<Fragment />
																	)}
																</div>
															)
														})}
												</div>
											</div>
										</div>
										<div className='bg-col-body-col-seperator' />
										<div className='bg-col-body-col'>
											<div className='bg-col-body-col-head'>Categories</div>
											<div className='bg-col-body-col-search'>
												<CategorySearch
													currentlySelected={item.get_categories}
													updateHandler={selections =>
														this.props.handleCatProdChange(selections, 'get_categories')
													}
													disabled={item.get_products.length > 0 || item.get_categories.length > 0}
												/>
												<div className='selected-item-wrapper'>
													{!!item.get_categories &&
														item.get_categories.map((category, i) => {
															return (
																<div key={i} className='selected-item-qty-container'>
																	<div className='selected-item'>
																		<div className='txt'>{category.title}</div>
																		<input
																			type='hidden'
																			name='get_categories[]'
																			value={category.id}
																		/>
																		<span
																			className='icon-cross delete-category'
																			onClick={() => {
																				this.props.handleCatProdDelete(i, 'get_categories')
																			}}
																		/>
																	</div>
																	{!!item.errors && !!item.errors.discount_qty && (
																		<div
																			className='error msg_animate'
																			style={{ margin: '0.75em 0em' }}
																		>
																			{item.errors.discount_qty}
																		</div>
																	)}
																	<div className='qty-group'>
																		<div className='qty-label'>Max Quantity: </div>
																		<input
																			type='number'
																			placeholder='Enter quantity'
																			value={item.discount_qty}
																			onChange={e =>
																				this.props.handleChange(
																					e.target.value,
																					index,
																					'discount_qty'
																				)
																			}
																		/>
																	</div>
																</div>
															)
														})}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className='discount-edit-row3'>
							<BuyXGetYField
								type={'number'}
								item={item}
								field={'max_uses'}
								label={'Max Coupon Code Uses'}
								placeholder={'Enter number. Leave blank for unlimited.'}
								handleChange={(value, field) => this.props.handleChange(value, index, field)}
							/>
							<BuyXGetYField
								type={'date'}
								item={item}
								field={'start_date'}
								label={'Effective Date Start'}
								placeholder={'START DATE'}
								handleChange={(value, field) => this.props.handleChange(value, index, field)}
							/>
							<BuyXGetYField
								type={'date'}
								item={item}
								field={'end_date'}
								label={'Effective Date End'}
								placeholder={'END DATE'}
								handleChange={(value, field) => this.props.handleChange(value, index, field)}
							/>
						</div>

						<div className='discount-eligible'>
							<div className='custom-label checkbox-label nobuyitems-checkbox'>
								<input
									type='checkbox'
									id='give_free_shipping'
									checked={item.give_free_shipping}
									onChange={e => this.props.handleCheckboxClick(index, 'give_free_shipping')}
								/>
								<label htmlFor='give_free_shipping'>Applies Free Shipping</label>
							</div>
						</div>

						<div className='discount-edit-row4'>
							<div>
								{!!item.errors && !!item.errors.form && (
									<div className='error msg_animate'>{item.errors.form}</div>
								)}
								{this.props.success && (
									<div className='success msg_animate'>{this.props.success}</div>
								)}
								<button
									className={'btn ' + (updateLoading ? ' loading' : '')}
									disabled={updateLoading}
									onClick={() => this.props.addItem()}
								>
									<span>{editId !== null ? 'Update' : 'Add New'}</span>
								</button>
								{editId !== null && (
									<button
										className={'btn ' + (updateLoading ? ' loading' : '')}
										disabled={updateLoading}
										onClick={() => this.props.resetDiscountForm()}
									>
										<span>Reset</span>
									</button>
								)}
							</div>
						</div>
					</div>
				)}
			</Fragment>
		)
	}
}

export default BuyXGetY



// WEBPACK FOOTER //
// ./src/components/admin/discounts/BuyXGetY.js